import React from "react"
import { cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider";
import { useRenderStyling } from "lib/hooks/useRenderStyling"

export default function LetterClosingRender(){

  const { mode, formatter, getElementConfig, parseApiData, getApiFeedData }:any = useTemplatePreviewCtx()
  const config = getElementConfig("letter_closing")

  const outerStyling = useRenderStyling("mm-section w-full pl-2", "styleObj")

  return(
    <div id="mm-letter-closing" {...outerStyling}>
      <p>Sincerely,<br/>
      { getApiFeedData("merch.DBA") } Finance Department
      </p>
    </div>
  )
}